import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delay, finalize, takeUntil, tap } from 'rxjs/operators';

import {
  BulkDatabaseVersion,
  BulkRecipientRequest,
  CreateScheduledMessageBulk2Command,
  CustomResultOfGetWhiteMessageCalculationsDto,
  GenderType,
  GetScheduledMessageCalculationsByBulk2Query,
  SendTypes,
  SimType,
  SmsAggregator,
} from 'src/app/core/api/models';
import { ScheduledMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { CampaignsFormComponent } from '../campaigns/campaigns-form/campaigns-form.component';
import { SendSmsFromMapComponent } from '../send-sms-from-map/send-sms-from-map.component';

@Component({
  selector: 'app-send-sms-from-map2',
  templateUrl: './send-sms-from-map2.component.html',
  styleUrls: [
    '../base/base-sending-system.component.scss',
    '../send-sms-from-map/send-sms-from-map.component.scss',
  ],
  standalone: false,
})
export class SendSmsFromMap2Component
  extends SendSmsFromMapComponent
  implements OnInit, OnDestroy
{
  get bulkDatabaseVersion() {
    return BulkDatabaseVersion;
  }
  tabName: string = 'sendSMSFromMap2';

  constructor(
    public dynamicTabService: DynamicTabService,
    protected translate: TranslateService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected currentService: ScheduledMessagesService,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super(
      dynamicTabService,
      translate,
      dialogService,
      utilityService,
      currentService,
      tabsDynamicComponent
    );
    this.baseCreateGetApiForSend(
      this.currentService,
      'scheduledMessagesCreateGet'
    );
  }

  configBaseSendSMS() {
    try {
      this.title = 'pages.sendSmsFromMap.title2';
      this.baseSendSmsConfig = {
        title: 'pages.sendSmsFromMap.title2',
        isEdit: false,
        msgInfoClassList: 'md:tw-w-1/3 tw-mt-2',
        isShowExtraReceivers: false,
        sendDateTimeClassList: 'md:tw-w-1/3 tw-mt-2',
        isShowReceivers: false,
        isShowFastSend: false,
        isShowPageHeader: false,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        sendType: SendTypes.Bulk2,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  setBulkRecipients() {
    let requestModel: CreateScheduledMessageBulk2Command = {};
    requestModel = this.model;
    requestModel.bulkRecipients = [];
    if (this.postalCodes != null && this.postalCodes.length > 0) {
      this.postalCodes.forEach((item) => {
        let serverQuery: BulkRecipientRequest = {};
        //generate hamrah aval
        if (item.hamrahAvalInfo != null) {
          serverQuery = {
            stateId: item.stateId,
            cityId: item.cityId,
            aggregatorType: SmsAggregator.MCI,
            zipCode: Number.parseInt(item.postalCode),
            simType: SimType.All,
            fromIndex: item.hamrahAvalInfo.startFrom,
            totalCount: item.hamrahAvalInfo.totalCount,
            count: item.hamrahAvalInfo.sendCount,
            genderTye: GenderType.All,
            description: item.hamrahAvalInfo.description,
          };
          requestModel.bulkRecipients.push(serverQuery);
        }
        //generate irancell
        if (item.irancellInfo != null) {
          serverQuery = {
            stateId: item.stateId,
            cityId: item.cityId,
            aggregatorType: SmsAggregator.Irancell,
            zipCode: Number.parseInt(item.postalCode),
            simType: SimType.All,
            fromIndex: item.irancellInfo.startFrom,
            totalCount: item.irancellInfo.totalCount,
            count: item.irancellInfo.sendCount,
            genderTye: GenderType.All,
            description: item.irancellInfo.description,
          };
          requestModel.bulkRecipients.push(serverQuery);
        }
      });
    }

    this.model = requestModel;
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      this.setBulkRecipients();
      if (
        this.model.bulkRecipients.length >
        this.currentUserInfo?.bulkRecipientsCountLimitation
      ) {
        this.dialogService.openDialog({
          message: this.translate.instant('messages.bulkRecipientsLimitation', {
            count: this.currentUserInfo?.bulkRecipientsCountLimitation,
          }),
          title: this.translate.instant('common.error'),
          status: DialogStatus.error,
        });
        return;
      }

      this.scheduledMessageCalculationsApi({
        smsText: this.model.smsBody,
        senderNumberId: this.model.senderNumberId,
        bulkRecipients: this.model.bulkRecipients,
        voiceMessageId: this.model?.voiceMessageDetails?.voiceMessageId || null,
        socialMediaDetails: this.model?.socialMediaDetails || null,
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  scheduledMessageCalculationsApi(
    model: GetScheduledMessageCalculationsByBulk2Query
  ) {
    this.unSubs();
    this.loading = true;
    this.calcLoading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageCalculationsByBulk2({ body: model })
      .pipe(
        delay(500),
        tap((res: CustomResultOfGetWhiteMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators(),
        finalize(() => (this.calcLoading = false))
      )
      .subscribe();
  }

  createScheduledMessageBulkApi(
    requestModel: CreateScheduledMessageBulk2Command
  ) {
    this.unSubs();
    this.loading = true;
    this.sendLoading = true;

    this.currentService
      .scheduledMessagesCreateScheduledMessageBulk2Post({
        body: requestModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result?.isSucceed) {
            this.onSuccess();
            this.refreshPage();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }
  onSaveToCampaign(event) {
    try {
      this.setBulkRecipients();
      this.model.saveToCampaign = event;
      const modalResult = this.dialogService.openModal({
        component: CampaignsFormComponent,
        data: { model: this.model, sendType: SendTypes.Bulk2 },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          this.model.saveToCampaign = res?.isSaveAfterSend;
          if (res?.campaignId) this.model.campaignId = res?.campaignId;
          if (res?.title) this.model.title = res?.title;
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
}
